import { createTheme } from "@mui/material";

const theme = createTheme({
  primary: "#FF0088",
  background: "#000000",
  lightBackground: "#333333",
  text: {
    primary: "#fff",
    secondary: "#999",
  },
});

export default theme;
